import { __assign, __rest } from "tslib";
import React from 'react';
import VeltTranscriptionSummaryExpandToggleWireframe from './VeltTranscriptionSummaryExpandToggleWireframe/VeltTranscriptionSummaryExpandToggleWireframe';
import VeltTranscriptionSummaryTextWireframe from './VeltTranscriptionSummaryTextWireframe/VeltTranscriptionSummaryTextWireframe';
import { transformWireframeProps } from '../../../utils/propUtils';
var VeltTranscriptionSummaryWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-transcription-summary-wireframe", __assign({}, transformedProps), children));
};
VeltTranscriptionSummaryWireframe.ExpandToggle = VeltTranscriptionSummaryExpandToggleWireframe;
VeltTranscriptionSummaryWireframe.Text = VeltTranscriptionSummaryTextWireframe;
export default VeltTranscriptionSummaryWireframe;
